import type { SchoolRequestFormInput } from '../validation/school-request.schemas';

interface RezumatCerereProps {
  date: SchoolRequestFormInput;
}

/**
 * Rezumat read-only al cererii, aratat in dialogul de confirmare a salvarii -- ca
 * profesorul sa reconfirme datele inainte de trimitere, nu doar sa apese "Salveaza"
 * fara sa mai vada ce a completat.
 */
export function RezumatCerere({ date }: RezumatCerereProps) {
  const adresa = [
    date.adresa?.strada,
    date.adresa?.numar,
    date.adresa?.oras || date.adresa?.comuna || date.adresa?.sat,
    date.adresa?.judet,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div className="space-y-1.5 rounded-md border border-input bg-gray-50 p-3">
      <RandRezumat eticheta="Școală" valoare={date.numeInstitutieInvatamant} />
      <RandRezumat eticheta="Cod SIIIR" valoare={date.codSiiirUnitate} />
      <RandRezumat eticheta="Telefon" valoare={date.telefon} />
      <RandRezumat eticheta="Număr elevi" valoare={date.numarElevi} />
      <RandRezumat eticheta="Reprezentant legal" valoare={date.numeReprezentatLegal} />
      <RandRezumat eticheta="Adresă" valoare={adresa} />
    </div>
  );
}

function RandRezumat({ eticheta, valoare }: { eticheta: string; valoare: string | number | undefined | null }) {
  return (
    <p>
      <span className="text-small font-medium text-gray-700">{eticheta}:</span>{' '}
      <span className="text-medium text-gray-900">{valoare || valoare === 0 ? valoare : '-'}</span>
    </p>
  );
}
